'use client';
import React from 'react';

const Card: React.FC<React.PropsWithChildren<{className?: string, id?: string}>> = ({children, className, id}) => (
  <section 
    className={`rounded-2xl p-6 ${className || ''}`} 
    style={{background:'rgba(255,255,255,.08)', backdropFilter:'blur(8px)'}}
    id={id}
  >
    {children}
  </section>
);

export default function PrivacyPage(){
  const tocItems: [string, string][] = [
    ['#1','1. Термины и контакты'],
    ['#2','2. Категории данных'],
    ['#3','3. Источники и способы'],
    ['#4','4. Цели и правовые основания'],
    ['#5','5. Cookies и аналитика'],
    ['#6','6. Хранение и сроки'],
    ['#7','7. Передача третьим лицам'],
    ['#8','8. Трансграничная передача'],
    ['#9','9. Права субъекта'],
    ['#10','10. Безопасность'],
    ['#11','11. Дети'],
    ['#12','12. Изменения политики'],
    ['#13','13. Контакты DPO/Ответственного'],
  ];

  return (
    <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-gray-100">
        <header className="px-6 pt-32 pb-16 md:pt-40 md:pb-20"
          style={{ background: 'linear-gradient(rgba(0,0,0,.45), rgba(0,0,0,.25)), radial-gradient(1200px 600px at 70% -10%, rgba(255,255,255,.08), transparent)' }}>
          <div className="max-w-7xl mx-auto">
          <span className="inline-block px-2.5 py-1 rounded-full bg-white/15 text-sm">Юридическая информация</span>
          <h1 className="text-4xl md:text-6xl font-extrabold mt-3">Политика конфиденциальности</h1>
          <p className="mt-3 text-lg md:text-xl max-w-3xl text-blue-100">
            Описаны категории собираемых персональных данных, цели их использования, порядок хранения, а также права субъектов персональных данных.
          </p>
          <div className="mt-6 flex flex-wrap gap-3 text-sm">
            <span className="px-2.5 py-1 rounded-xl bg-white/15">Оператор: ООО «INTERIM»</span>
            <span className="px-2.5 py-1 rounded-xl bg-white/15">Последнее обновление: 18 ноября 2025</span>
          </div>
          <div className="mt-8 flex flex-wrap gap-4">
            <a href="#policy" className="px-4 py-3 rounded-xl font-semibold bg-white/10">Перейти к документу</a>
            <button onClick={()=>typeof window !== 'undefined' && window.print()} className="px-4 py-3 rounded-xl font-semibold" style={{background:'#FFC300', color:'#102a43'}}>Печать / PDF</button>
          </div>
        </div>
      </header>

      <main id="policy" className="px-6 py-12 md:py-16 max-w-5xl mx-auto space-y-6 scroll-mt-32">
        <Card>
          <h2 className="text-2xl font-bold mb-3">Оглавление</h2>
          <nav className="grid sm:grid-cols-2 gap-2 text-sm">
            {tocItems.map(([href,label])=>(
              <a key={href} href={href} className="block px-3 py-2 rounded-xl bg-white/10 hover:bg-white/20">{label}</a>
            ))}
          </nav>
        </Card>
        
        <Card className="scroll-mt-24" id="1">
          <h3 className="text-xl font-bold">1. Термины и контакты</h3>
          <p className="mt-2">Оператор персональных данных: ООО «Кадровое агентство ИНТЕРИМ» («мы»).</p>
          <p className="mt-2">Адрес: г Грозный, р-н Ахматовский, ул Им. С.Ш.Лорсанова, д. 4. E-mail: <a href="mailto:info@interimjob.ru" className="underline">info@interimjob.ru</a>. Тел.: +7 (963) 703-09-20.</p>
          <p className="mt-2">Документ применяется к сайтам и сервисам INTERIM, на которые ссылается данная политика.</p>
        </Card>

        <Card id="2" className="scroll-mt-32">
          <h3 className="text-xl font-bold">2. Категории данных</h3>
          <ul className="list-disc ml-6 space-y-1 mt-2">
            <li>Идентификационные: имя, должность, компания.</li>
            <li>Контактные: e-mail, телефон, мессенджеры.</li>
            <li>Кандидатские: резюме, портфолио, ссылки на профили (обрабатываются только с явного согласия).</li>
            <li>Деловые: реквизиты договоров, история взаимодействий.</li>
            <li>Технические: IP-адрес, информация о браузере (User-Agent), cookie-идентификаторы, события аналитики.</li>
            <li>Платёжные: только реквизиты платежа, которые обрабатывает платёжный провайдер (мы не храним карточные данные).</li>
          </ul>
        </Card>

        <Card id="3" className="scroll-mt-32">
          <h3 className="text-xl font-bold">3. Источники и способы получения</h3>
          <p className="mt-2">Данные предоставляются вами через формы сайта, по e-mail/телефону, при заключении договоров, а также собираются автоматически через файлы cookie и пиксели аналитики.</p>
        </Card>

        <Card id="4" className="scroll-mt-32">
          <h3 className="text-xl font-bold">4. Цели и правовые основания</h3>
          <ul className="list-disc ml-6 space-y-1 mt-2">
            <li>Обработка резюме, поиск и подбор персонала, формирование кадрового резерва (основание: согласие субъекта).</li>
            <li>Ответ на запросы, подготовка предложений, заключение и исполнение договоров (основание: договор/преддоговор).</li>
            <li>Оказание услуг подбора, аутсорсинга, аутстаффинга (основание: договор).</li>
            <li>Рассылки по согласованным темам (основание: согласие; можно отозвать в любой момент).</li>
            <li>Аналитика и улучшение сервисов, защита от злоупотреблений (основание: законный интерес).</li>
            <li>Выполнение требований закона (основание: правовая обязанность).</li>
          </ul>
        </Card>

        <Card id="5" className="scroll-mt-32">
          <h3 className="text-xl font-bold">5. Cookies и аналитика</h3>
          <p className="mt-2">
            Строго необходимые cookie обеспечивают безопасность и функциональность сайта (например, запоминают ваше согласие) и используются без предварительного согласия.
          </p>
          <p className="mt-2">
            Аналитические, функциональные и маркетинговые cookie используются только после получения Вашего явного и активного согласия через наш Менеджер согласия. Вы вправе изменить свое решение в любой момент.
          </p>
          <p className="mt-2">
            &rarr; <a href="/cookies" className="underline font-semibold text-sky-300">Перейти к Менеджеру согласия на Cookies</a>.
          </p>
        </Card>

        <Card id="6" className="scroll-mt-32">
          <h3 className="text-xl font-bold">6. Хранение и сроки</h3>
          <p className="mt-2">Срок хранения зависит от цели: договорные данные — срок договора и требования закона; коммуникации — до 3 лет; кандидатские — до 24 месяцев или до отзыва согласия.</p>
        </Card>

        <Card id="7" className="scroll-mt-32">
          <h3 className="text-xl font-bold">7. Передача третьим лицам</h3>
          <ul className="list-disc ml-6 space-y-1 mt-2">
            <li>Провайдерам ИТ-сервисов (хостинг, почтовая и календарная инфраструктура, CRM/ATS, аналитика).</li>
            <li>Платёжным операторам (при оплате услуг).</li>
            <li>Партнёрам и заказчикам при оказании услуг рекрутинга — строго по договору и при наличии правового основания.</li>
            <li>Госорганам — в рамках требований закона.</li>
          </ul>
        </Card>

        <Card id="8" className="scroll-mt-32">
          <h3 className="text-xl font-bold">8. Трансграничная передача</h3>
          <p className="mt-2">
            Мы осуществляем передачу данных за пределы Российской Федерации только в случаях, когда это необходимо для исполнения договора (например, передача резюме иностранному Заказчику) или при наличии Вашего отдельного, явного согласия на такую передачу. Мы применяем механизмы защиты в соответствии с законодательством.
          </p>
        </Card>

        <Card id="9" className="scroll-mt-32">
          <h3 className="text-xl font-bold">9. Права субъекта данных</h3>
          <ul className="list-disc ml-6 space-y-1 mt-2">
            <li>Доступ к данным и получение копии.</li>
            <li>Уточнение/исправление, ограничение обработки.</li>
            <li>Удаление при отсутствии законных оснований для хранения.</li>
            <li>Отзыв согласия и отказ от маркетинговых рассылок.</li>
            <li>Переносимость — при технической возможности.</li>
            <li>Жалоба в уполномоченный орган.</li>
          </ul>
          <p className="mt-2">Запросы направляйте на <a className="underline" href="mailto:info@interimjob.ru">info@interimjob.ru</a>.</p>
        </Card>

        <Card id="10" className="scroll-mt-32">
          <h3 className="text-xl font-bold">10. Меры безопасности</h3>
          <p className="mt-2">Мы обеспечиваем защиту ваших данных с помощью современных организационных и технических мер: минимизация прав доступа сотрудников, многофакторная аутентификация, шифрование данных при передаче, резервное копирование, аудит действий и обучение персонала. Практики информационной безопасности основаны на требованиях российского стандарта ГОСТ Р ИСО/МЭК 27001.</p>
        </Card>

        <Card id="11" className="scroll-mt-32">
          <h3 className="text-xl font-bold">11. Обработка данных детей</h3>
          <p className="mt-2">Сервис не ориентирован на несовершеннолетних; данные детей не собираем намеренно.</p>
        </Card>

        <Card id="12" className="scroll-mt-32">
          <h3 className="text-xl font-bold">12. Изменения политики</h3>
          <p className="mt-2">Мы можем обновлять документ. Новая редакция действует с момента публикации на сайте. Дата последнего обновления указана вверху страницы.</p>
        </Card>

        <Card id="13" className="scroll-mt-32">
          <h3 className="text-xl font-bold">13. Контакты DPO/ответственного</h3>
          <p className="mt-2">DPO/Ответственный: И.Мусаев E-mail: <a className="underline" href="mailto:info@interimjob.ru">info@interimjob.ru</a>, тел. +7 (963) 703-09-20.</p>
          <div className="mt-4 flex flex-wrap gap-3">
            <a href="#policy" className="px-4 py-3 rounded-xl font-semibold bg-white/10">К началу</a>
            <button onClick={()=>typeof window !== 'undefined' && window.print()} className="px-4 py-3 rounded-xl font-semibold" style={{background:'#FFC300', color:'#102a43'}}>Скачать как PDF</button>
          </div>
        </Card>
      </main>
    </div>
  );
}